// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable, combineLatest, filter, map, of } from 'rxjs';
import { authPortalUserState, identityState } from '../app-states/app.state';
import { LoadIdentity } from '../app-states/actions/app.actions';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { AppEnvironmentService } from '../services/app-environment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private store: Store, private auth: AuthService, private router: Router, private appEnv: AppEnvironmentService) {

  }

  canActivate(): Observable<boolean> {
  
    const id_token = localStorage.getItem("id_token");

    if (!id_token) {
      this.auth.clearStorage();
      this.router.navigate(['login'])
      return of(false);
    } else {
      this.store.dispatch(LoadIdentity({ payload: {idToken: id_token} }));
      const authUserState$ = this.store.pipe(select(authPortalUserState));
      const identityState$ = this.store.pipe(select(identityState));
      this.auth.showAuthCheckingModal();
      return combineLatest(([authUserState$, identityState$, this.auth.authStateModalSubject]))
        .pipe(filter(([authUserState, identityState]) => authUserState.status === 'loaded' && identityState.status === 'checked'),
          map(([authUserState, identityState]) => {
            
            if (identityState.identity === null) {
              window.location.href = this.appEnv.appEnvData.reloadSessionExpired;
              return false;
              
            }
            this.auth.closeAuthCheckingModal();
            return true;
          }))
    }

  }

}
